function FinalScoreEditor({
 game,
 finalScoreForm,
 setFinalScoreForm,
 handleSaveFinalScore,
 onCancel,
}) {
 const hasBothTeams = Boolean(game?.home_team_id && game?.away_team_id);
 const hasBothPlayers = Boolean(game?.home_player_id && game?.away_player_id);
 const canEditFinalScore = hasBothTeams || hasBothPlayers;
 
 return (
  <div className="final-score-inline-editor">
   {!canEditFinalScore && (
    <p className="final-score-inline-warning">
     Add both sides before entering a final score.
    </p>
   )}
   <div className="final-score-inline-input-group">
    <input
     type="number"
     disabled={!canEditFinalScore}
     value={finalScoreForm.score_home === "" ? "" : finalScoreForm.score_home}
     onChange={(e) => {
      const value = e.target.value;
      setFinalScoreForm((prev) => ({
       ...prev,
       score_home: value === "" ? "" : parseInt(value, 10),
      }));
     }}
     aria-label={`${game?.homeTeam?.name || "Home"} score`}
    />

    <span className="final-score-inline-vs">vs</span>

    <input
     type="number"
     disabled={!canEditFinalScore}
     value={finalScoreForm.score_away === "" ? "" : finalScoreForm.score_away}
     onChange={(e) => {
      const value = e.target.value;
      setFinalScoreForm((prev) => ({
       ...prev,
       score_away: value === "" ? "" : parseInt(value, 10),
      }));
     }}
     aria-label={`${game?.awayTeam?.name || "Away"} score`}
    />
   </div>

   <div className="final-score-inline-actions">
    <button
     type="button"
     className="final-score-inline-cancel"
     onClick={onCancel}
    >
     Cancel
    </button>
    <button
     type="button"
     className="final-score-inline-save"
     onClick={handleSaveFinalScore}
     disabled={!canEditFinalScore}
    >
     Save
    </button>


   </div>
  </div>
 );
}

export default FinalScoreEditor;